import { __decorate, __metadata, __param } from "tslib";
import AuthInfoEntity from '../entity/auth-info-entity';
import CollabAuthInfoEntity from '../entity/collab-auth-info-entity';
import CorpShareAuthInfoEntity from '../entity/corp-share-auth-info-entity';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
var AuthAggregate = /** @class */ (function () {
    function AuthAggregate(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
        this.authInfoEntity = new AuthInfoEntity(docMetaDomainService, networkRequestService);
        this.corpShareAuthInfoEntity = new CorpShareAuthInfoEntity(docMetaDomainService, networkRequestService);
        this.collabAuthInfoEntity = new CollabAuthInfoEntity(docMetaDomainService, networkRequestService);
    }
    AuthAggregate = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], AuthAggregate);
    return AuthAggregate;
}());
export default AuthAggregate;
